export default __webpack_public_path__ + "static/media/ic_barcode.e391bfc5.svg";